import { SVGProps } from 'react'

interface RectangleProps extends SVGProps<SVGSVGElement> {
  variant?: 'left' | 'right'
}

export const Rectangle = ({ variant, ...props }: RectangleProps) => {
  switch (variant) {
    case 'left':
      return (
        <svg
          width="112"
          height="112"
          viewBox="0 0 112 112"
          fill="none"
          {...props}
        >
          <rect
            width="111.631"
            height="111.631"
            transform="matrix(-1 0 0 1 111.631 0)"
            fill="url(#paint0_radial_4249_21779)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_4249_21779"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(92.0953 21.2098) rotate(135.526) scale(129.064 204.549)"
            >
              <stop offset="0.530589" stopColor="white" stopOpacity="0" />
              <stop offset="0.585931" stopColor="white" stopOpacity="0.01" />
              <stop
                offset="0.630967"
                stopColor="white"
                stopOpacity="0.0324148"
              />
              <stop offset="0.667282" stopColor="white" stopOpacity="0.0704" />
              <stop
                offset="0.696462"
                stopColor="white"
                stopOpacity="0.120652"
              />
              <stop
                offset="0.720092"
                stopColor="white"
                stopOpacity="0.181481"
              />
              <stop offset="0.739759" stopColor="white" stopOpacity="0.2512" />
              <stop
                offset="0.757047"
                stopColor="white"
                stopOpacity="0.328119"
              />
              <stop
                offset="0.773542"
                stopColor="white"
                stopOpacity="0.410548"
              />
              <stop offset="0.790831" stopColor="white" stopOpacity="0.4968" />
              <stop
                offset="0.810497"
                stopColor="white"
                stopOpacity="0.585185"
              />
              <stop
                offset="0.834128"
                stopColor="white"
                stopOpacity="0.674015"
              />
              <stop offset="0.863308" stopColor="white" stopOpacity="0.7616" />
              <stop
                offset="0.899623"
                stopColor="white"
                stopOpacity="0.846252"
              />
              <stop
                offset="0.944658"
                stopColor="white"
                stopOpacity="0.926281"
              />
              <stop offset="1" stopColor="white" />
            </radialGradient>
          </defs>
        </svg>
      )
    case 'right':
      return (
        <svg
          width="112"
          height="112"
          viewBox="0 0 112 112"
          fill="none"
          {...props}
        >
          <rect
            width="111.631"
            height="111.631"
            fill="url(#paint0_radial_4249_21778)"
          />
          <defs>
            <radialGradient
              id="paint0_radial_4249_21778"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(92.0953 21.2098) rotate(135.526) scale(129.064 204.549)"
            >
              <stop offset="0.530589" stopColor="white" stopOpacity="0" />
              <stop offset="0.585931" stopColor="white" stopOpacity="0.01" />
              <stop
                offset="0.630967"
                stopColor="white"
                stopOpacity="0.0324148"
              />
              <stop offset="0.667282" stopColor="white" stopOpacity="0.0704" />
              <stop
                offset="0.696462"
                stopColor="white"
                stopOpacity="0.120652"
              />
              <stop
                offset="0.720092"
                stopColor="white"
                stopOpacity="0.181481"
              />
              <stop offset="0.739759" stopColor="white" stopOpacity="0.2512" />
              <stop
                offset="0.757047"
                stopColor="white"
                stopOpacity="0.328119"
              />
              <stop
                offset="0.773542"
                stopColor="white"
                stopOpacity="0.410548"
              />
              <stop offset="0.790831" stopColor="white" stopOpacity="0.4968" />
              <stop
                offset="0.810497"
                stopColor="white"
                stopOpacity="0.585185"
              />
              <stop
                offset="0.834128"
                stopColor="white"
                stopOpacity="0.674015"
              />
              <stop offset="0.863308" stopColor="white" stopOpacity="0.7616" />
              <stop
                offset="0.899623"
                stopColor="white"
                stopOpacity="0.846252"
              />
              <stop
                offset="0.944658"
                stopColor="white"
                stopOpacity="0.926281"
              />
              <stop offset="1" stopColor="white" />
            </radialGradient>
          </defs>
        </svg>
      )

    default:
      return null
  }
}
